import {
  type SupplierCertificateType,
  SUPPLIER_CERTIFICATE_LABELS
} from '@tandemone/types'

import { Badge } from '@/components/ui/badge'
import { cn } from '@/lib/utils'

import { getCertFamily } from './cert-family'

export function CertBadge({
  certification,
  className
}: {
  certification: SupplierCertificateType
  className?: string
}) {
  return (
    <Badge
      className={cn(
        'shrink-0',
        getCertFamily(certification).className,
        className
      )}
    >
      {SUPPLIER_CERTIFICATE_LABELS[certification]}
    </Badge>
  )
}
